/**
 * Sports Carousel Slider
 * Horizontal scrolling sports carousel with arrow navigation
 */
document.addEventListener('DOMContentLoaded', function() {
  const slideshowContainer = document.querySelector('.slideshow-container-sports');
  if (!slideshowContainer) return;
  
  const container = slideshowContainer.querySelector('.sports-carousel-wrapper');
  if (!container) return;

  const cols = Array.from(container.querySelectorAll('.sports-carousel-col'));
  if (cols.length === 0) return;

  // Create arrow buttons if they don't exist
  let leftArrow = slideshowContainer.querySelector('.sports-carousel-arrow-left');
  let rightArrow = slideshowContainer.querySelector('.sports-carousel-arrow-right');
  
  if (!leftArrow) {
    leftArrow = document.createElement('button');
    leftArrow.className = 'sports-carousel-arrow sports-carousel-arrow-left';
    leftArrow.setAttribute('aria-label', 'Previous sport');
    leftArrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#75b4cf" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
    slideshowContainer.appendChild(leftArrow);
  }
  
  if (!rightArrow) {
    rightArrow = document.createElement('button');
    rightArrow.className = 'sports-carousel-arrow sports-carousel-arrow-right';
    rightArrow.setAttribute('aria-label', 'Next sport');
    rightArrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#75b4cf" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
    slideshowContainer.appendChild(rightArrow);
  }

  // Function to scroll to a specific index
  function scrollToIndex(index) {
    if (index < 0 || index >= cols.length) return;
    
    const target = cols[index];
    if (target) {
      container.scrollTo({
        left: target.offsetLeft - (container.offsetWidth - target.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }
  }

  // Function to get current visible index
  function getCurrentIndex() {
    const scrollLeft = container.scrollLeft;
    let index = 0;
    cols.forEach((col, i) => {
      if (col.offsetLeft <= scrollLeft + container.offsetWidth / 2) {
        index = i;
      }
    });
    return index;
  }

  // Function to update arrow visibility
  function updateArrows() {
    const currentIndex = getCurrentIndex();
    leftArrow.style.display = currentIndex === 0 ? 'none' : 'flex';
    rightArrow.style.display = currentIndex === cols.length - 1 ? 'none' : 'flex';
  }

  // Left arrow click handler
  leftArrow.addEventListener('click', () => {
    const currentIndex = getCurrentIndex();
    if (currentIndex > 0) {
      scrollToIndex(currentIndex - 1);
    }
  });

  // Right arrow click handler
  rightArrow.addEventListener('click', () => {
    const currentIndex = getCurrentIndex();
    if (currentIndex < cols.length - 1) {
      scrollToIndex(currentIndex + 1);
    }
  });

  // Initial arrow state
  updateArrows();

  // Touch handlers for mobile - snap to nearest card on swipe end
  let snapTimeout = null;
  let isUserScrolling = false;

  // Update arrows and handle snap-to on scroll
  container.addEventListener('scroll', () => {
    updateArrows();
    
    // Clear any pending snap
    if (snapTimeout) {
      clearTimeout(snapTimeout);
    }
    
    // Set flag that user is scrolling
    isUserScrolling = true;
    
    // After scrolling stops, snap to nearest card
    snapTimeout = setTimeout(() => {
      if (isUserScrolling) {
        const currentScroll = container.scrollLeft;
        const containerWidth = container.offsetWidth;
        const containerCenter = currentScroll + containerWidth / 2;
        
        // Find the card whose center is closest to the container center
        let closestCol = cols[0];
        let closestDistance = Math.abs((cols[0].offsetLeft + cols[0].offsetWidth / 2) - containerCenter);
        
        cols.forEach((col) => {
          const colCenter = col.offsetLeft + col.offsetWidth / 2;
          const distance = Math.abs(colCenter - containerCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestCol = col;
          }
        });
        
        // Only snap if we're not already close to a card
        if (closestDistance > 50) {
          container.scrollTo({
            left: closestCol.offsetLeft - (containerWidth - closestCol.offsetWidth) / 2,
            behavior: 'smooth'
          });
        }
        
        isUserScrolling = false;
      }
    }, 150);
  });
});

